import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

export default function VideoCard({ video, size = 'normal' }: { video: VideoItem; size?: 'normal' | 'large' | 'small' }) {
  const formatViews = (num: number) => {
    if (num >= 10000) {
      return (num / 10000).toFixed(1) + '万';
    }
    return num.toString();
  };

  const sizeClasses = {
    large: 'col-span-2 row-span-2',
    normal: '',
    small: '',
  };

  return (
    <Link
      to={`/article/${video.id}`}
      className={`group block ${sizeClasses[size]}`}
    >
      <article className="bg-background-100 border border-background-300/60 rounded-lg overflow-hidden hover:border-primary-500/30 transition-all duration-300 hover:translate-y-[-2px] h-full flex flex-col">
        <div className="relative overflow-hidden aspect-video">
          <img
            src={video.thumbnail}
            alt={video.title}
            title={`${video.title} - 黑料视频`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

          <div className="absolute top-3 left-3 flex items-center gap-2">
            {video.isHot && (
              <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                热门
              </span>
            )}
            {video.isNew && (
              <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-background-950 whitespace-nowrap">
                最新
              </span>
            )}
          </div>

          <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/70 text-foreground-200 text-xs whitespace-nowrap">
            {video.duration}
          </div>

          <div className="absolute bottom-0 left-0 right-0 flex justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 pb-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
              <i className="ri-play-fill text-xl ml-0.5"></i>
            </div>
          </div>
        </div>

        <div className="p-4 flex flex-col flex-1">
          <h3 className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors duration-200 line-clamp-2 leading-snug mb-2">
            {video.title}
          </h3>
          <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3 flex-1">
            {video.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-600">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-eye-line"></i>
                {formatViews(video.views)}
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-chat-3-line"></i>
                {formatViews(video.comments)}
              </span>
            </div>
            <span className="whitespace-nowrap">{video.publishDate}</span>
          </div>
        </div>
      </article>
    </Link>
  );
}